import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=f66dda4e&scoped=true"
import script from "./TabItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TabItem.vue?vue&type=style&index=0&id=f66dda4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66dda4e",
  null
  
)

export default component.exports